/**
 * Update Kiosk Settings Use Case
 * Business logic for updating kiosk settings with delta calculation
 */

import { KioskSettingsRepository } from '../data/kiosk-settings-repository';
import { KioskSettingsJson } from '../types/kiosk-settings-types';

export class UpdateKioskSettingsUseCase {
  constructor(private readonly repository: KioskSettingsRepository) {}

  async execute(
    operatorId: number,
    countryCode: string | undefined,
    partyId: string | undefined,
    parentId: number | null | undefined,
    current: KioskSettingsJson,
    original: KioskSettingsJson
  ): Promise<void> {
    return this.repository.updateSettings(
      operatorId,
      countryCode,
      partyId,
      parentId,
      current,
      original
    );
  }
}
